import axios from 'axios'
import qs from 'qs'
axios.defaults.baseURL = 'https://api2.home.didigo.es/'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
//axios.defaults.withCredentials =true;
axios.defaults.timeout = 60000 //1分种的超时请求时间

export const index = (type,page,page_number,recommend) => axios.post('admin/admin/index', qs.stringify({
    type,page,page_number,recommend
}))